// src/pages/manager/sessions/SessionsList.jsx
import React from "react";
import { useParams } from "react-router-dom";
import SessionsList from "../../../components/attendance/SessionsList";

const ManagerSessionsList = () => {
    const { id } = useParams(); // present when routed via /manager/batches/:id/sessions
    const initialBatchId = id ? Number(id) : undefined;
    return <SessionsList role="MANAGER" initialBatchId={initialBatchId} />;
};

export default ManagerSessionsList;
